import React from "react";

class Subscribe extends React.Component {
  render() {
    var backgrounds = {
      spaceship: {
        backgroundImage:
          "url(https://cdn.illpackus.com/backgrounds/spaceship_left.png)"
      }
    };
    return (
      <section
        className="theme-bg-left"
        style={backgrounds.spaceship}
        id="early-access"
      >
        <div className="container">
          <div className="row">
            <div className="col-sm-12 col-md-6 offset-md-6 col-lg-4 offset-lg-8">
              <h3 className="text-white sign-up-prompt">
                Sign up for early access!
              </h3>
              <div className="email-box early-access">
                <div id="mc_embed_signup">
                  <form
                    action="https://illpackus.us20.list-manage.com/subscribe/post?u=e0a5db6979af3e01641986a61&amp;id=953e127ddb"
                    method="post"
                    id="mc-embedded-subscribe-form"
                    name="mc-embedded-subscribe-form"
                    className="validate"
                    target="_blank"
                    novalidate
                  >
                    <div id="mc_embed_signup_scroll">
                      <div className="mc-field-group">
                        <input
                          type="email"
                          name="EMAIL"
                          className="required email form-control"
                          id="mce-EMAIL"
                          placeholder="Email Address"
                        />
                      </div>
                      <div id="mce-responses" className="clear">
                        <div
                          className="response display-none"
                          id="mce-error-response"
                        />
                        <div
                          className="response display-none"
                          id="mce-success-response"
                        />
                      </div>
                      <div className="mc-bot" aria-hidden="true">
                        <input
                          type="text"
                          name="b_e0a5db6979af3e01641986a61_953e127ddb"
                          tabindex="-1"
                          value=""
                        />
                      </div>
                      <div className="clear">
                        <input
                          type="submit"
                          value="Subscribe"
                          name="subscribe"
                          id="mc-embedded-subscribe"
                          className="btn btn-email"
                        />
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }
}

export default Subscribe;



// WEBPACK FOOTER //
// ./src/components/subscribe.js